import { styled, Typography } from '@mui/material';

export const ControlTitle = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 700,
  color: theme.palette.text.primary,
  letterSpacing: '0.01em',
}));
